import React, { useState, useEffect } from 'react';
import { AlertBanner as AlertBannerPrimitive } from '@app/ui';
import { InfoCircleFilled } from '@ant-design/icons';

interface AlertBannerProps {
    message: string | React.ReactNode;
    context?: 'warning' | 'error' | 'info' | 'success';
    closable?: boolean;
}

const AlertBanner: React.FC<AlertBannerProps> = ({
    message,
    context = 'warning',
    closable = true,
}) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (message) {
            setIsVisible(true);
        }
    }, [message]);

    if (!isVisible || !message) return null;

    return (
        <AlertBannerPrimitive
            message={message}
            severity={context}
            style={{
                marginTop: 24,
            }}
            showIcon
            icon={<InfoCircleFilled style={{ color: 'var(--main-brand-color)', marginRight: 8 }} />}
            closable={closable}
            onClose={() => setIsVisible(false)}
        />
    );
};

export default AlertBanner;
